<app-modal-wrapper *ngIf="asModal && !userCreated">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</app-modal-wrapper>
<ng-container *ngIf="!asModal && !userCreated">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>
<ng-container *ngIf="userCreated">
  <ng-container *ngTemplateOutlet="successUser"></ng-container>
</ng-container>

<ng-template #content>
  <app-modal-content [modalTitle]="forceTitle || formTitle"
                     successBtnContent="Сохранить" i18n-successBtnContent
                     (successModal)="save()"
                     (closeModal)="canceled.emit()">

    <button *ngIf="!isProd" (click)="debug()">Debug</button>
    <button *ngIf="!isProd" (click)="pduPerformer()">PDU_PERF</button>

    <form class="user-window" [formGroup]="form">
      <div class="user-window__image">
        <figure class="user-window__image-item">
          <app-image-picker [url]="user?.picture?.url"
                            (removed)="pictureRemoved()"
                            (changed)="pictureChanged($event)"></app-image-picker>
        </figure>
      </div>
      <div class="user-window__fields">
        <div class="user-window__fields-input">
          <mat-form-field class="standart-outline" appearance="outline"
                          appFVWrapper>
            <mat-label i18n>Имя</mat-label>
            <input matInput
              type="text" appFV
              [formControl]="form.controls.name"
            />
          </mat-form-field>
        </div>
        <div class="user-window__fields-input">
          <mat-form-field class="standart-outline" appearance="outline"
                          appFVWrapper [class.read-only]="user?.id">
            <mat-label i18n>Логин</mat-label>
            <input matInput appFV
                   (dblclick)="debug()"
                   type="text"
                   [formControl]="form.controls.username"
            />
          </mat-form-field>
        </div>
        <div class="user-window__fields-input">
          <mat-form-field class="standart-outline" appearance="outline"
                          controlErrorContainer>
            <mat-label i18n>Должность</mat-label>
            <input matInput
                   type="text"
                   [formControl]="form.controls.position"/>
          </mat-form-field>
        </div>

        <div class="user-window__fields-input" controlErrorContainer>
          <app-phone-input
            [control]="form.controls.phone"
            [phoneCountryControl]="form.controls.phoneCountry"
          ></app-phone-input>

        </div>

        <div class="user-window__fields-input">
          <mat-form-field class="standart-outline" appearance="outline" appFVWrapper>
            <mat-label i18n>Email</mat-label>
            <input matInput type="text" appFV [formControl]="form.controls.email"/>
          </mat-form-field>
        </div>

        <mat-form-field class="user-window__fields-input standart-outline" appearance="outline">
          <mat-label i18n>Заметки</mat-label>
          <input matInput type="text" [formControl]="form.controls.notes"/>
        </mat-form-field>

        <div class="user-window__fields-responsible gl-input" *ngIf="!hideIsResponsibleSwitcher">
          <p i18n>Ответственный</p>
          <mat-slide-toggle
            [formControl]="isResponsibleControl"
            class="disable-form-error"
            color="primary"
          ></mat-slide-toggle>
        </div>
      </div>

      <app-reset-password
        *ngIf="user?.id"
        [userId]="user.id"
      ></app-reset-password>
    </form>
  </app-modal-content>
</ng-template>

<ng-template #successUser>
  <app-modal-content [hiddenButtons]="['success', 'close']"
                     (closeModal)="done.emit(user);">
    <div class="user-add-success">
      <p class="user-add-success__user">
        <span i18n>Пользователь</span>
        {{ user?.name }}
        <span i18n> добавлен.</span>
      </p>
      <p class="user-add-success__password">
        <span i18n>Пароль:</span>
        <span [cdkCopyToClipboard]="user?.password" (cdkCopyToClipboardCopied)="passwordCopied()">
          {{ user?.password }}
        </span>
      </p>
    </div>
  </app-modal-content>
</ng-template>
